export default __webpack_public_path__ + "static/media/7.cca55c8c.jpeg";